// extracted by mini-css-extract-plugin
export default {"container":"BW-z","modal":"CW-z","dimensions":"DW-z","brandName":"EW-z","productName":"FW-z","recipientEmail":"GW-z","recommendedFit":"HW-z","hiddenField":"IW-z"};